import $ from "jquery";
import "select2";

$(() => {
    $(".select2").select2({
        placeholder: function () {
            $(this).data("placeholder");
        },
    });

    $(".select2_1").select2({
        placeholder: function () {
            $(this).data("placeholder");
        },
        maximumSelectionLength: 1,
    });

    $(".establishments-select2").select2({
        width: '100%',
        closeOnSelect: false,
        placeholder: '',
        maximumSelectionLength: 1,
        ajax: {
          url: "/establishment/search/dropdown",
          dataType: 'json',
          delay: 250,
          data: function (query) {
            // add any default query here
            return query;
          },
          processResults: function (data) {
            // Tranforms the top-level key of the response object from 'items' to 'results'
            var results = [];
            data.forEach(e => {
              results.push({ id: e.id, text: e.name });
            });

            console.log(results);

             return {
               results: results,
             };
          },
        },
      });
});
